import { useNavigate } from 'react-router-dom'
import { StyledButton } from '../../../../../../components'
import classes from './StudentForm.module.css'
import { SuccesAnimation } from '../../../../../../assets/images'
export const StudentSucess = ({ success, setSuccess }) => {
  const navigate = useNavigate()
  return (
    <div className={classes.sucess} style={{ width: '393px' }}>
      <img src={SuccesAnimation} alt="" className={classes.succiessicoj} />
      <p className={classes.xtxt}>New Admission Recorded</p>
      <br />
      <br />
      <StyledButton
        onClick={() => {
          navigate('/dashboard')
        }}
        modal={true}
      >
        Okay
      </StyledButton>
    </div>
  )
}
